"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAccessListUint8Array = isAccessListUint8Array;
exports.isAccessList = isAccessList;
function isAccessListUint8Array(input) {
    if (input.length === 0) {
        return true;
    }
    const firstItem = input[0];
    if (Array.isArray(firstItem)) {
        return true;
    }
    return false;
}
function isAccessList(input) {
    return !isAccessListUint8Array(input); // This is exactly the same method, except the output is negated.
}
//# sourceMappingURL=types.js.map